import { Routes, Route, Navigate } from "react-router-dom";
import AppLayout from "../ui/templates/layouts/AppLayout";
import AuthLayout from "../ui/templates/layouts/AuthLayout";
import { withAuth } from "../hocs/withAuth";
import Home from "../ui/pages/Home";
import ChangePassword from "../ui/pages/ChangePassword";
import ChangeEmail from "../ui/pages/ChangeEmail";
import ChangePhoneNumber from "../ui/pages/ChangePhoneNumber";
import ChangeProfile from "../ui/pages/ChangeProfile";
import Redirect from "../pages/redirect";
import Communication from "../pages/communication";
import DeleteAccount from "../ui/pages/DeleteAccount";
import AccountVerificaiton from "../ui/pages/AccountVerificaiton";
import AddPhoneNumber from "../ui/pages/AddPhoneNumber";
import FAQ from "../ui/pages/FAQ";
import AccountInfo from "../ui/pages/AccountInfo";

// Protected Components
const ProtectedChangePassword = withAuth(ChangePassword);
const ProtectedChangeEmail = withAuth(ChangeEmail);
const ProtectedChangePhoneNumber = withAuth(ChangePhoneNumber);
const ProtectedChangeProfile = withAuth(ChangeProfile);
const ProtectedRedirect = withAuth(Redirect);
const ProtectedCommunication = withAuth(Communication);
const ProtectedDeleteAccount = withAuth(DeleteAccount);
const ProtectedHome = withAuth(Home);
const ProtectedAccountVerificaiton = withAuth(AccountVerificaiton);
const ProtectedAddPhoneNumber = withAuth(AddPhoneNumber);
const ProtectedAccountInfo = withAuth(AccountInfo);

const MainRoute = () => (
  <Routes>
    <Route element={<AppLayout />}>
      <Route path="/change-password" element={<ProtectedChangePassword />} />
      <Route path="/change-email" element={<ProtectedChangeEmail />} />
      <Route path="/change-phone" element={<ProtectedChangePhoneNumber />} />
      <Route path="/change-profile" element={<ProtectedChangeProfile />} />
      <Route path="/redirect" element={<ProtectedRedirect />} />
      <Route path="/communication" element={<ProtectedCommunication />} />
      <Route path="/user-delete" element={<DeleteAccount />} />
      <Route path="/" element={<ProtectedHome />} />
      <Route path="/account-info" element={<ProtectedAccountInfo />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Route>

    <Route element={<AuthLayout />}>
      <Route path="/verify/code" element={<ProtectedAccountVerificaiton />} />
      <Route path="/verify/phone" element={<ProtectedAddPhoneNumber />} />
      <Route path="/support" element={<FAQ />} />
    </Route>
  </Routes>
);

export default MainRoute;
